import { GetCustomKeyframe, GetPointAnimation } from "./buildBanner";
import libraryIn from '../store/libraryIn.json';
import libraryOut from '../store/libraryOut.json';

export async function ConvertStepActive(banner, position, end) {
  let bannerCopy = { ...banner };
  var html = `<html>              
  <head>
      <meta charset="UTF-8">
      <meta name="apple-mobile-web-app-capable" content="yes">
      <meta name="viewport" content="minimum-scale=1,maximum-scale=1,width=device-width,user-scalable=no">
      <meta name="ad.size" content="width=${bannerCopy.width},height=${bannerCopy.height}">
          <!-- /* a cima dimensão do banner */ -->
      <script type="text/javascript">
          var clickTag = "http://www.google.com"
      </script>
      <title>Reanimate_${bannerCopy.width}x${bannerCopy.height}</title>
          <!-- /* a nomeclatura da peça */ -->
      <style>
        body {
          margin: 0;
          padding: 0;
          width: ${bannerCopy.width}px;
          height: ${bannerCopy.height};
          position: relative;
        }

        #clickArea {
            position: absolute;
            top: 0;
            left: 0;
            z-index: 999
        }

        #clickArea img {
            border: 0
        }

        #banner {
            -moz-box-sizing: border-box;
            -webkit-box-sizing: border-box;
            -webkit-user-select: none;
            -ms-user-select: none;
            user-select: none;
            box-sizing: border-box;
            overflow: hidden;
            position: relative;
            width: ${bannerCopy.width}px;
            height: ${bannerCopy.height}px;
            top: 0;
            left: 0;
            cursor: pointer;
            background-color: ${bannerCopy.backgroundColor === undefined ? '#fff' : bannerCopy.backgroundColor};
            border: ${bannerCopy.bannerBorder === undefined ? 'solid 0.75px  #aeaeae': bannerCopy.bannerBorder };
        }
        
        #banner:after {
          position: absolute;
          content: '';
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          z-index: 900
      }

      body {
        overflow: hidden;
      }

      #banner:before {
          position: absolute;
          content: '';
          left: 0;
          top: 0;
          width: calc(100% - 2px);
          height: calc(100% - 2px);
          z-index: 901;
      }`;
  bannerCopy.elements.forEach(async (el) => {
    if ((el.step < position) & (el.fixo === true) || ((el.step < position) & (el.stepout > position))) {
      el.fixo === false ?
      html += `
      .${el.id} {
      ${
        el.properties.background
          ? `background: url('${el.properties.background}') no-repeat;`
          : ""
      }
      width: ${Math.ceil(el.properties.width * el.properties.scale / 100)}px;
      height: ${Math.ceil(el.properties.height * el.properties.scale / 100)}px;
      left: ${el.properties.left}px;
      top: ${el.properties.top}px;
      position: absolute;
      opacity: ${el.properties.opacity};
      z-index: ${el.properties.zIndex};
      background-size: ${el.reduce === true ? 'none' : 'contain'};
    }` :    
    
    html += `
    .${el.id} {
    ${
      el.properties.background
        ? `background: url('${el.properties.background}') no-repeat;`
        : ""
    }
    width: ${Math.ceil(el.properties.width * el.properties.scale / 100)}px;
    height: ${Math.ceil(el.properties.height * el.properties.scale / 100)}px;
    left: ${el.properties.left}px;
    top: ${el.properties.top}px;
    position: absolute;
    opacity: 1;
    z-index: ${el.properties.zIndex};
    background-size: ${el.reduce === true ? 'none' : 'contain'};
  }` 
    }
    if (el.step === position || (el.step >= position) & (end === true) || (el.step < position) & (el.stepout > position)) {
      html += `
        .${el.id} {
        ${
          el.properties.background
            ? `background: url('${el.properties.background}') no-repeat;`
            : ""
        }
        width: ${Math.ceil(el.properties.width * el.properties.scale / 100)}px;
        height: ${Math.ceil(el.properties.height * el.properties.scale / 100)}px;
        left: ${el.properties.left}px;
        top: ${el.properties.top}px;
        position: absolute;
        opacity: ${el.properties.opacity};
        z-index: ${el.properties.zIndex};
        background-size: ${el.reduce === true ? 'none' : 'contain'};
      }`;
    }
  });
  html += "</style>";
  html += `<style>
  @keyframes Estatico_Left_1000_IN {
    0% { opacity: 1 }100% { opacity: 1  }
    }
    
    .Estatico_Left_1000_IN {
              opacity: 1;
    
              animation: Estatico_Left_1000_IN 1000ms 1 forwards ;
              
            }
            
            </style>
            
            `;

  html += bannerCopy.animation;
  html += "</head>";
  let buildBody = await BuildActiveStep(bannerCopy, position, end);
  html += buildBody.body;
  html += "</html>";
  return html;
}

export function BuildActiveStep(banner, stepPosition, end) {
  try {
    banner.preset = BuildPresetActiveStep(banner, stepPosition, end);
    var timeline = BuildExtremeTimeline(banner.preset); 
    var body = "";
    body += BuildActiveStepBody(banner, stepPosition, end);
    body += GetPointAnimation(banner) + timeline;
    body += `
      //#TIMELINE#
      if (count > 0) {
        timeline.animationElements("LOOPING", [
          [".banner", 4]
        ], function () {
            animabanner()
          });
      }
    }
    
    var count = ${banner.loop};
  
    animabanner();
    </script>`;
    body.replace("#{count}#", banner.loop);
    banner.body = body;
    banner.animation = buildKeyframes(banner);
    return banner;
  } catch (error) {}
}

function BuildPresetActiveStep(banner, stepPosition, end) {
  try {
    const presetExtreme = [];
    const steps = banner.elements[banner.elements.length - 1].step;
    for (var i = 1; i <= steps; i++) {
      let aux = i;
      const elements = banner.elements.filter((el) => el.step === aux);
      for (var j = 0; j < elements.length; j++) {
        const element = elements[j];
        const custom = element.animation.in.customKeyframe
          ? GetCustomKeyframe(
              banner.customKeyframe,
              element.animation.in.animation
            )
          : null;
        var delay = element.animation.in.delay;
        var duration = element.animation.in.duration;
        var animation = custom
          ? custom.animation
          : element.animation.in.animation;
        var direction = element.animation.in.direction;
        if (
          element.fixo === true ||
          element.step === stepPosition ||
          (end === true) & (element.step >= stepPosition) ||
          element.step < stepPosition & element.stepout > stepPosition
        ) {
          element.fixo === true & stepPosition > element.step || element.step < stepPosition & element.stepout > stepPosition  ?
          presetExtreme.push({
            name: element.id,
            delay: 0, 
            animation: "Estatico",
            direction: direction,
            duration: duration,
            type: "IN",
            step: element.step,
            parent: element.parent,
            children: element.children,
            loop: element.loop,
            customKeyframe: custom,
          })
          :
          presetExtreme.push({
            name: element.id,
            delay: delay,
            animation: animation,
            direction: direction,
            duration: duration,
            type: "IN",
            step: element.step,
            parent: element.parent,
            children: element.children,
            loop: element.loop,
            customKeyframe: custom,
            
          })
        }
      }

      if (end === true) {
        if (aux < steps) {
          const elementsOut = banner.elements.filter(
            (el) => el.stepout === aux + 1
          );
          for (j = 0; j < elementsOut.length; j++) {
            if (!elementsOut[j].fixo) {
              try {
                const element = elementsOut[j];
                const custom = element.animation.out.customKeyframe
                  ? GetCustomKeyframe(
                      banner.customKeyframe,
                      element.animation.out.animation
                    )
                  : null;
                delay = element.animation.out.delay;
                duration = element.animation.out.duration;
                animation = custom
                  ? custom.animation
                  : element.animation.out.animation;
                direction = element.animation.out.direction;
                presetExtreme.push({
                  name: element.id,
                  delay: delay,
                  animation: animation,
                  direction: direction,
                  duration: duration,
                  type: "OUT",
                  step: element.step,
                  parent: element.parent,
                  children: element.children,
                  loop: element.loop,
                  customKeyframe: custom,
                });
              } catch (error) {}
            }
          }
        }
      }
    }
    return presetExtreme;
  } catch (error) {}
}

export function BuildExtremeTimeline(preset) {
  var timeline = "";
  var timeline2 = "";
  var count = 2;
  var childrens = false;
  preset.forEach(item => {
    childrens = false;
    if (!item.parent) {
      var animationName = "";
      if (item.customKeyframe) {
        animationName = item.animation;
      } else {
        animationName = `${item.animation}_${item.direction}_${item.duration}_${item.type.toUpperCase()}`;
        animationName += item.loop > 1 ? `_iteration_${item.loop}` : item.loop === -1 ? `_iteration_infinite` : "";
      }
      timeline += `timeline.animationElements("${animationName}", [
        [".${item.name}", ${item.delay}]//,${item.type.toUpperCase()}
      ]);`
      timeline2 = `var timeline_${count} = new Point_Animation();
      timeline.animationElements("STOP_HERE", [
        [".${item.name}", 0]//,${item.type.toUpperCase()}
      ], function() {`;
      preset.forEach(children => {
        if (children.parent === item.name && children.type.toUpperCase() === "IN") {
          childrens = true;
          if (children.customKeyframe) {
            animationName = children.animation;
          } else {
            animationName = `${children.animation}_${children.direction}_${children.duration}_${children.type.toUpperCase()}`;
            animationName += children.loop > 1 ? `_iteration_${children.loop}` : children.loop === -1 ? `_iteration_infinite` : "";
          }
          timeline2 += `timeline_${count}.animationElements("${animationName}", [
            [".${children.name}", ${children.delay}]//,${item.type.toUpperCase()}
          ]);`
        }
      });
      timeline2 += "});";
      if (childrens) {
        timeline += timeline2;
        count++;
      } else {
        timeline2 = "";
      }
    }
  });
  return timeline;
}

function BuildActiveStepBody(banner, stepPosition, end) {
  var body = `<body>`;
  body += banner.audio
    ? `
    <audio id="player">
      <source src="data:audio/${banner.audio.ext};${
        banner.audio.b64
      }" type="audio/${banner.audio.ext}">
    </audio>
    <div id='click-sound'>
      <svg style="cursor: pointer;fill: ${
        banner.audio.bg ? "black" : "white"
      };display: none;width: 15px;position: absolute;top: 10px;${
        banner.audio.direction
      }: 10px;z-index: 999;" version="1.1" id="sound-on" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 122.88 94.98" style="enable-background:new 0 0 122.88 94.98" xml:space="preserve"><style type="text/css">.st0{fill-rule:evenodd;clip-rule:evenodd;}</styl><g><path class="st0" d="M5.06,20.78h20.67c0.43,0,0.79,0.35,0.79,0.79v44.72c0,0.43-0.35,0.79-0.79,0.79H5.05 C2.27,67.07,0,64.8,0,62.02V25.85C0,23.06,2.28,20.78,5.06,20.78L5.06,20.78z M109.14,1.06c5.01,7.08,8.82,15.04,11.14,23.57 c2.24,8.22,3.1,16.97,2.33,25.94c-0.7,8.2-2.7,15.99-5.79,23.18c-2.59,6.03-5.95,11.64-9.93,16.7c-0.62,0.82-1.25,1.63-1.9,2.43 l-0.05-0.05c-0.31,0.36-0.62,0.72-0.94,1.07l-0.94,1.06l-0.92-1.08l-3.73-4.38l-0.69-0.81l0.7-0.8c4.54-5.23,8.3-11.2,11.06-17.73 c2.66-6.29,4.39-13.11,4.99-20.29c0.68-7.98-0.08-15.75-2.06-23.05c-1.83-6.75-4.7-13.11-8.44-18.86l-0.02-0.02 c-0.68-0.99-1.39-1.97-2.13-2.92l0.08-0.07l-0.05-0.07l0.97-0.72l0.71-0.53l2.71-2.19l0.09,0.12l1.05-0.78l1.02-0.76L109.14,1.06 L109.14,1.06z M108.58,4.66c-0.25-0.38-0.49-0.75-0.75-1.12l-0.03,0.02C108.07,3.92,108.33,4.29,108.58,4.66L108.58,4.66z M92.75,12.19c3.68,5.28,6.47,11.21,8.17,17.55c1.64,6.12,2.26,12.61,1.7,19.27c-0.48,5.68-1.8,11.11-3.83,16.17 c-2.1,5.23-4.95,10.05-8.4,14.32l-0.94,1.16l-0.97-1.14l-4.72-3.29l-0.66-0.77l0.62-0.8c2.91-3.72,6.01-7.87,7.77-12.35 c1.7-4.33,2.1-8.99,2.51-13.88c0.5-5.86-0.04-11.55-1.47-16.9c-1.34-5.04-3.48-9.8-6.27-14.11c-0.37-0.53-0.75-1.06-1.15-1.58 l0.05-0.04l-0.46-0.66l0.96-0.71L91,11.9l1.03-0.76L92.75,12.19L92.75,12.19z M89.84,15.13l-0.31-0.47l-0.02,0.01L89.84,15.13 L89.84,15.13z M31,19.96C43.04,13.35,55.09,6.74,67.13,0.14c1.16-0.63,2.4,1.08,2.4,2.4v82.04c0,1.39-1.32,3.21-2.53,2.53L31,66.8 c-0.23-0.13-0.48-0.21-0.48-0.48V20.44C30.52,20.17,30.77,20.09,31,19.96L31,19.96z"/></g></svg>
    </div>  
    <svg style="cursor: pointer;fill: ${
      banner.audio.bg ? "black" : "white"
    };display: block;width: 15px;position: absolute;top: 10px;${
        banner.audio.direction
      }: 10px;z-index: 999;" id="sound-off" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 122.88 96"><title>volume-mute</title><path d="M12.81,22.46H38.34L59.46,1.18a4,4,0,0,1,5.66,0A3.91,3.91,0,0,1,66.31,4h0V92a4,4,0,0,1-6.9,2.81l-20.87-17H12.81A12.84,12.84,0,0,1,0,65V35.27A12.84,12.84,0,0,1,12.81,22.46Zm100.62,8.09a5.48,5.48,0,0,1,7.82,0,5.62,5.62,0,0,1,0,7.89L111.83,48l9.45,9.59a5.57,5.57,0,0,1-.06,7.85,5.49,5.49,0,0,1-7.79,0L104,55.9l-9.4,9.55a5.5,5.5,0,0,1-7.82,0,5.63,5.63,0,0,1,0-7.9L96.23,48,86.78,38.4a5.56,5.56,0,0,1,.06-7.84,5.47,5.47,0,0,1,7.79,0l9.4,9.52,9.4-9.54Z"/></svg>
    `
    : "";
    body += banner.audioIA
      ? `
      <audio id="player">
        <source src="data:audio/${banner.audioIA.ext};${
          banner.audioIA.b64
        }" type="audio/${banner.audioIA.ext}">
      </audio>
      <div id='click-sound'>
        <svg style="cursor: pointer;fill: ${
          banner.audioIA.bg ? "black" : "white"
        };display: none;width: 15px;position: absolute;top: 10px;${
          banner.audioIA.direction
        }: 10px;z-index: 999;" version="1.1" id="sound-on" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 122.88 94.98" style="enable-background:new 0 0 122.88 94.98" xml:space="preserve"><style type="text/css">.st0{fill-rule:evenodd;clip-rule:evenodd;}</styl><g><path class="st0" d="M5.06,20.78h20.67c0.43,0,0.79,0.35,0.79,0.79v44.72c0,0.43-0.35,0.79-0.79,0.79H5.05 C2.27,67.07,0,64.8,0,62.02V25.85C0,23.06,2.28,20.78,5.06,20.78L5.06,20.78z M109.14,1.06c5.01,7.08,8.82,15.04,11.14,23.57 c2.24,8.22,3.1,16.97,2.33,25.94c-0.7,8.2-2.7,15.99-5.79,23.18c-2.59,6.03-5.95,11.64-9.93,16.7c-0.62,0.82-1.25,1.63-1.9,2.43 l-0.05-0.05c-0.31,0.36-0.62,0.72-0.94,1.07l-0.94,1.06l-0.92-1.08l-3.73-4.38l-0.69-0.81l0.7-0.8c4.54-5.23,8.3-11.2,11.06-17.73 c2.66-6.29,4.39-13.11,4.99-20.29c0.68-7.98-0.08-15.75-2.06-23.05c-1.83-6.75-4.7-13.11-8.44-18.86l-0.02-0.02 c-0.68-0.99-1.39-1.97-2.13-2.92l0.08-0.07l-0.05-0.07l0.97-0.72l0.71-0.53l2.71-2.19l0.09,0.12l1.05-0.78l1.02-0.76L109.14,1.06 L109.14,1.06z M108.58,4.66c-0.25-0.38-0.49-0.75-0.75-1.12l-0.03,0.02C108.07,3.92,108.33,4.29,108.58,4.66L108.58,4.66z M92.75,12.19c3.68,5.28,6.47,11.21,8.17,17.55c1.64,6.12,2.26,12.61,1.7,19.27c-0.48,5.68-1.8,11.11-3.83,16.17 c-2.1,5.23-4.95,10.05-8.4,14.32l-0.94,1.16l-0.97-1.14l-4.72-3.29l-0.66-0.77l0.62-0.8c2.91-3.72,6.01-7.87,7.77-12.35 c1.7-4.33,2.1-8.99,2.51-13.88c0.5-5.86-0.04-11.55-1.47-16.9c-1.34-5.04-3.48-9.8-6.27-14.11c-0.37-0.53-0.75-1.06-1.15-1.58 l0.05-0.04l-0.46-0.66l0.96-0.71L91,11.9l1.03-0.76L92.75,12.19L92.75,12.19z M89.84,15.13l-0.31-0.47l-0.02,0.01L89.84,15.13 L89.84,15.13z M31,19.96C43.04,13.35,55.09,6.74,67.13,0.14c1.16-0.63,2.4,1.08,2.4,2.4v82.04c0,1.39-1.32,3.21-2.53,2.53L31,66.8 c-0.23-0.13-0.48-0.21-0.48-0.48V20.44C30.52,20.17,30.77,20.09,31,19.96L31,19.96z"/></g></svg>
      </div>  
      <svg style="cursor: pointer;fill: ${
        banner.audioIA.bg ? "black" : "white"
      };display: block;width: 15px;position: absolute;top: 10px;${
          banner.audioIA.direction
        }: 10px;z-index: 999;" id="sound-off" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 122.88 96"><title>volume-mute</title><path d="M12.81,22.46H38.34L59.46,1.18a4,4,0,0,1,5.66,0A3.91,3.91,0,0,1,66.31,4h0V92a4,4,0,0,1-6.9,2.81l-20.87-17H12.81A12.84,12.84,0,0,1,0,65V35.27A12.84,12.84,0,0,1,12.81,22.46Zm100.62,8.09a5.48,5.48,0,0,1,7.82,0,5.62,5.62,0,0,1,0,7.89L111.83,48l9.45,9.59a5.57,5.57,0,0,1-.06,7.85,5.49,5.49,0,0,1-7.79,0L104,55.9l-9.4,9.55a5.5,5.5,0,0,1-7.82,0,5.63,5.63,0,0,1,0-7.9L96.23,48,86.78,38.4a5.56,5.56,0,0,1,.06-7.84,5.47,5.47,0,0,1,7.79,0l9.4,9.52,9.4-9.54Z"/></svg>
      `
      : "";


  body += `<a href="javascript:window.open(window.clickTag)"><div id="banner" class="banner">`;
  banner.elements.forEach((element) => {
    if (
      element.fixo === true ||
      element.step === stepPosition ||
      element.step < stepPosition & element.stepout > stepPosition ||
      (end === true) & (element.step >= stepPosition)
      ) {


        if (element.children) {
        body += `<div id="${element.id}" class="${element.id}">`;
        banner.elements.forEach((children) => {
          if (children.parent === element.id) {
            body += `<div id="${children.id}" class="${children.id}"></div>`;
          }
        });
        }
        
        if(element.parent === null){
        body += `<div id="${element.id}" class="${element.id}">`;
        if (element.id.toLowerCase().includes("txt")) {
          element.category = "txt";
        } else if (element.id.toLowerCase().includes("bg")) {
          element.category = "bg";
        } else if (element.id.toLowerCase().includes("imga")) {
          element.category = "imgA";
        } else if (element.id.toLowerCase().includes("imgb")) {
            element.category = "imgB";
          } else if (element.id.toLowerCase().includes("imgc")) {
              element.category = "imgC";
            } else if (element.id.toLowerCase().includes("imgd")) {
                element.category = "imgD";
              } else element.category = "";
            // }
          }
            body += `</div>`;
          }


  });


  body += `</div>`;
  body += "</a></body>";
  return body;
}

export function KeyFrame(animation, banner) {
  var animationName = `${animation.name}_${animation.direction}_${animation.duration}_${animation.type.toUpperCase()}`;
  animationName += animation.loop > 1 ? `_iteration_${animation.loop}` : animation.loop === -1 ? `_iteration_infinite` : "";
  var key = `@keyframes ${animationName} {`;
  const arrayAnimations = animation.type.toLowerCase() === "in" ? libraryIn : libraryOut;
  try  {
    arrayAnimations.forEach(item => {
      if (animation.name.toLowerCase() === item.name.toLowerCase() && animation.type.toLowerCase() === item.type.toLowerCase()) {
        var cssItem = "\n";
        item.keyframe.forEach(element => {
          cssItem += element;
        });
        if (animation.type.toLowerCase() === "in") {
          if (animation.direction.toLowerCase() === "left") {
            cssItem = cssItem.replace("$left$", item.value ? item.value : banner.width * 2);
            cssItem = cssItem.replace("$top$", 0);
          } else if (animation.direction.toLowerCase() === "right") {
            cssItem = cssItem.replace("$left$", item.value ? -item.value : -banner.width * 2);
            cssItem = cssItem.replace("$top$", 0);
          } else if (animation.direction.toLowerCase() === "top") {
            cssItem = cssItem.replace("$top$", item.value ? item.value : banner.height * 2);
            cssItem = cssItem.replace("$left$", 0);
          } else {
            cssItem = cssItem.replace("$top$", item.value ? -item.value : -banner.height * 2);
            cssItem = cssItem.replace("$left$", 0);
          }
        } else {
          if (animation.direction.toLowerCase() === "left") {
            cssItem = cssItem.replace("$left$", item.value ? -item.value : -banner.width * 2);
            cssItem = cssItem.replace("$top$", 0);
          } else if (animation.direction.toLowerCase() === "right") {
            cssItem = cssItem.replace("$left$", item.value ? item.value : banner.width * 2);
            cssItem = cssItem.replace("$top$", 0);
          } else if (animation.direction.toLowerCase() === "top") {
            cssItem = cssItem.replace("$top$", item.value ? -item.value : -banner.height * 2);
            cssItem = cssItem.replace("$left$", 0);
          } else {
            cssItem = cssItem.replace("$top$", item.value ? item.value : banner.height * 2);
            cssItem = cssItem.replace("$left$", 0);
          }
        }
        key += cssItem + "\n}\n";
        key += "\n";
        key += `.${animationName} {
          ${item.opacity ? "opacity: 1;\n" : ""}
          animation: ${animationName} ${animation.duration}ms ${item.animation} ${animation.type.toLowerCase() === "out" ? "!important" : "" };
          ${animation.loop === -1 ? "animation-iteration-count: infinite;" : animation.loop > 1 ? `animation-iteration-count: ${animation.loop};` : ""}
        }\n`
      }
    });
  } catch(error) {
    return "";
  }
  return key;
}

export function BuildAnimationPreview(element, type) {
  if (!element) return null;
  var animation = type === "in" ? element.animation.in : element.animation.out;
  return Keyframe({name: animation.animation, direction: animation.direction, type: type, duration: animation.duration, loop: 1});
}

export function buildKeyframes(banner) {
  let bannerCopy = {...banner}
  var listAnimation = [];
  var keyframes = "<style>";
  bannerCopy.preset.forEach(element => {
    if (!element.customKeyframe) {
      listAnimation =
        AddArray(
          listAnimation,
          {
            name: element.animation,
            direction: element.direction,
            type: element.type,
            duration: element.duration,
            loop: element.loop
          }
        );
    }
  });

  if (bannerCopy.customKeyframe){

    bannerCopy.customKeyframe.forEach(custom => {
      keyframes += custom.keyframe;
    });
  } else{
    keyframes += ``
  }

  listAnimation.forEach(animation => {
    keyframes += KeyFrame(animation, bannerCopy);
  });
  let estaticoAnimation = {name: 'Estatico', direction: 'Left', type: 'IN', duration: 1000, loop: 1}
  keyframes += KeyFrame(estaticoAnimation, bannerCopy)
  
  return keyframes + "</style>";
}

export function Keyframe(animation) {
  var key =  "@keyframes ";
  const arrayAnimations = animation.type.toLowerCase() === "in" ? libraryIn : libraryOut;
  var animationName = `${animation.name}_${animation.direction}_${animation.duration}_${animation.type.toUpperCase()}`;
  key += animationName + " {\n";
  try  {
    arrayAnimations.forEach(item => {
      if (animation.name === item.name && animation.type === item.type) {
        var cssItem = "\n";
        item.keyframe.forEach(element => {
          cssItem += element;
        });
        if (animation.type.toLowerCase() === "in") {
          if (animation.direction.toLowerCase() === "left") {
            cssItem = cssItem.replace("$left$", item.value ? item.value : 240 * 2);
            // cssItem = cssItem.replace("$left$", 240 * 2);
            cssItem = cssItem.replace("$top$", 0);
          } else if (animation.direction.toLowerCase() === "right") {
            cssItem = cssItem.replace("$left$", item.value ? -item.value : -240 * 2);
            // cssItem = cssItem.replace("$left$", -240 * 2);
            cssItem = cssItem.replace("$top$", 0);
          } else if (animation.direction.toLowerCase() === "top") {
            cssItem = cssItem.replace("$top$", item.value ? item.value : 160 * 2);
            // cssItem = cssItem.replace("$top$", 160 * 2);
            cssItem = cssItem.replace("$left$", 0);
          } else {
            cssItem = cssItem.replace("$top$", item.value ? -item.value : -160 * 2);
            // cssItem = cssItem.replace("$top$", -160 * 2);
            cssItem = cssItem.replace("$left$", 0);
          }
        } else {
          if (animation.direction.toLowerCase() === "left") {
            cssItem = cssItem.replace("$left$", item.value ? -item.value : -240 * 2);
            // cssItem = cssItem.replace("$left$", -240 * 2);
            cssItem = cssItem.replace("$top$", 0);
          } else if (animation.direction.toLowerCase() === "right") {
            cssItem = cssItem.replace("$left$", item.value ? item.value : 240 * 2);
            // cssItem = cssItem.replace("$left$", 240 * 2);
            cssItem = cssItem.replace("$top$", 0);
          } else if (animation.direction.toLowerCase() === "top") {
            cssItem = cssItem.replace("$top$", item.value ? -item.value : -160 * 2);
            // cssItem = cssItem.replace("$top$", -160 * 2);
            cssItem = cssItem.replace("$left$", 0);
          } else {
            cssItem = cssItem.replace("$top$", item.value ? item.value : 160 * 2);
            // cssItem = cssItem.replace("$top$", 160 * 2);
            cssItem = cssItem.replace("$left$", 0);
          }
        }
        key += cssItem + "\n}\n";
        key += "\n";
        key += `.${animationName} {
          animation: ${animationName} ${animation.duration}ms ${item.animation} ${animation.type === "out" ? "!important" : "" };
        }\n`
      }
    });
  } catch(error) {
    return "";
  }
  return {style: key, name: animationName}
}

function AddArray (array, item) {
  var aux = true;
  array.forEach(element => {
    if (`${element.name}${element.direction}${element.type}${element.duration}${element.loop}` === `${item.name}${item.direction}${item.type}${item.duration}${item.loop}`) {
      aux = false;
    }
  });
  if (aux) {
      array.push(item)
  }
  
  return array;
}


